<template>
  <div>
    <div>
      <table class="table">
        <tr
        v-if="attachment.key == 'story_attachment'"
        v-for="attachment in story.attachments"
        :key="attachment.id">
          <td>
            <a
              :href="`attachments/${story.folder_uri}${attachment.value}` | static_url"
              target="_blank"
              class="text-break text-secondary">
              {{ attachment.meta.filename }}
            </a>
            <br>
          </td>
          <td>
            <div class="text-right">
              <a href
                @click.prevent
                v-clipboard:success="onCopy"
                v-clipboard:copy="`attachments/${$env.VUE_APP_STATIC_BASE_URL}/${story.folder_uri}${attachment.value}`"
                class="">
                <i class="fa fa-copy"></i>
              </a>
              <a href @click.prevent="deleteAttachment(attachment.id)" class="">
                <i class="fa fa-trash"></i>
              </a>
            </div>
          </td>
        </tr>
        <tr v-if="story.attachments && story.attachments.length == 0" colspan="2">
          <p class="text-muted text-center">
            <small>
              Aucune pièce jointe pour l’instant
            </small>
          </p>
        </tr>
      </table>
    </div>
    <hr>
    <div class="text-right">
      <el-upload
        :show-file-list="false"
        :action="`stories/${$route.params.id}/upload-attachment/` | api_url"
        :http-request="uploadAttachment">
        <el-button size="small" type="primary">
          <i class="fa fa-upload"></i>
          Pièces jointes
        </el-button>
      </el-upload>
    </div>
    <!-- {{ story.attachments }} -->
  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'story-editor-attachments',
  computed: mapGetters({
    constants: 'constants',
    story: 'story'
  }),
  components: {},
  props: {},
  data () {
    return {
      mask: 'id,title,headline,content,attachments,folder_uri'
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {},
    uploadAttachment (option) {
      const formData = new FormData()
      formData.append('attachment', option.file)
      this.$store.dispatch('uploadStoryAttachment', {
        formEncodedData: formData,
        storyId: this.$route.params.id,
        headers: {
          'X-Fields': this.mask,
        }
      }).then(() => {})
    },
    deleteAttachment (attachmentId) {
      this.$confirm('Supprimer cette pièce jointe. Continuer ?', 'Warning', {
        confirmButtonText: 'Supprimer',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('deleteStoryAttachment', {
          storyId: this.$route.params.id,
          attachmentId: attachmentId,
          headers: {
            'X-Fields': this.mask,
          }
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Pièce jointe supprimée'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Suppression annulée'
        })
      })
    },
    onCopy: function (e) {
      this.$message({
        type: 'success',
        message: 'URL copiée'
      })
    },
  }
}
</script>
<style scoped>

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
